import { defineItemMigration } from "@editor/items/itemStoreMigration";
import type { StoreItem } from "@editor/items/StoreItem";
import type { ResourceItem } from "../ResourceItem";

export default defineItemMigration<ResourceItem, LegacyResourceItem>(
  (itemStore, oldCondition, newCondition) => {
    if (oldCondition.displayPosition === "footer") {
      newCondition.displayPosition = "foreground";
    }
  }
);

interface LegacyResourceItem extends StoreItem {
  id: number;
  type: "resource";

  title: string;
  description: string;

  value: number;
  unit: string;
  minValue: number;
  maxValue: number;
  
  displayPosition: "net" | "footer" | "hidden";

  order: number;
}
